import packageJson from '../../package.json';

export const SHIPPING_MODULE_VERSION =
  packageJson.dependencies['@kustom-checkout/shipping'];
